<template>
  <UploadFileModal
    :isOpen="openModals.new"
    :close="openNewModal"
    :reload="reload"
    v-if="openModals.new"
  />
  <FileDetailModal
    :isOpen="openModals.detail"
    :close="openDetailModal"
    :reload="reload"
    v-if="openModals.detail"
    :selectedFile="selectedFile"
  />
  <div class="inline-block min-width-full overflow-hidden rounded-lg shadow bg-white p-4">
    <b-row class="my-4 min-width-full align-items-center">
      <b-col md="4">
        <b-input-group>
          <b-form-input
            id="inline-form-input-name"
            class=" mr-sm-2 md-4"
            placeholder="파일명 입력하세요."
            v-model="search.title"
            v-on:keyup.enter="handleSearch"
          ></b-form-input>
          <b-input-group-append>
            <button class="btn btn-primary" v-on:click="handleSearch">검색</button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col md="8" class="text-right">
        <Button :type="BadgeTypes.purple" label="등록" :on-click="openNewModal"/>
      </b-col>
    </b-row>
    <b-table :fields="fields" :items="files" class="text-left">
      <template #cell(lessonTitle)="data">
            <span v-if="data.item.lessonTitle.length > 0">
              <Badge
                :type="data.item.status === FilePublishTypes.UNPUBLISHED ? BadgeTypes.red : BadgeTypes.green"
                :label="data.item.status"
              />
               {{`${data.item.lessonTitle} (${data.item.lessonContentTitle})`}}
            </span>
      </template>
      <template #cell(url)="data">
        <p class="cursor" @click="copy(data.item.url)">{{getURL(data.item.url)}}</p>
      </template>
      <template #cell(popupContent)="data">
        {{`${data.item?.popupContent || ""}`}}
      </template>
      <template #cell(button)="data">
        <div class="inline-flex gap-2 justify-end items-center text-right w-full">
          <Button :type="ButtonTypes.blue" label="상세" :onClick="() => setDetail(data.item)" />
          <Button :type="ButtonTypes.red" label="삭제" :onClick="() => deleteFile(data.item.id)" />
        </div>
      </template>
    </b-table>
    <b-pagination
      align="center"
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="pageSize"
      @page-click="changePage"
    />
  </div>
</template>
<script>
import api from "@/api/api";
import {copyText} from "vue3-clipboard";
import {BadgeTypes, ButtonTypes, PublishTypes} from "@/util/enums";
import UploadFileModal from "@/components/modals/UploadFileModal.vue";
import Badge from "@/components/Badge.vue";
import Button from "@/components/Button.vue";
import FileDetailModal from "@/components/modals/FileDetailModal.vue";

export default {
  computed: {
    ButtonTypes() {
      return ButtonTypes
    },
    BadgeTypes() {
      return BadgeTypes
    },
    FilePublishTypes() {
      return PublishTypes
    }
  },
  components: {FileDetailModal, Button, Badge, UploadFileModal},
  data() {
    return {
      searchLessons: [],
      currentPage: 1,
      pageSize: 30,
      totalPage: 0,
      totalRows: 0,
      openModals: {
        new: false,
        detail: false
      },
      selectedLesson: {},
      fields: [
        {
          label: '이름',
          key: 'name',
        },
       
        {
          label: 'URL',
          key: 'url',
        },
        {
          label: '파일명',
          key: 'fileName',
        },
        {
          label: '연결된 강의',
          key: 'lessonTitle',
        },
        {
          label: '팝업 내용',
          key: 'popupContent',
        },
        {
          label: '',
          key: 'button',
          thStyle: { width: "20%" },
        }
      ],
      files: [],
      search: {
        title: "",
        checkDeleted: false
      },
      selectedFile: null,
    }
  },
  mounted() {
    // URL query params에서 상태 복원
    const query = this.$route.query
    if (query.page) {
      this.currentPage = parseInt(query.page)
    }
    if (query.keyword) {
      this.search.title = query.keyword
    }
    
    this.getPagingList(this.currentPage)
  },
  methods: {
    getURL(url) {
      return `https://file.kessam.com/${url}`
    },
    copy(url){
      const fullURL = this.getURL(url)
      copyText(fullURL, fullURL, (err, event) => {
        this.$toast.show(err ? '복사 할 수 없습니다.' : '복사 완료',
          {
            position: "top-right",
            duration: 2000
          });
      })
    },
    openNewModal() {
      this.openModals.new = !this.openModals.new
    },
    openDetailModal() {
      this.openModals.detail = !this.openModals.detail
    },
    setDetail(selectedFile) {
      this.selectedFile = selectedFile
      this.openDetailModal()
    },
    reload(){
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    handleSearch() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    changePage(event, page){
      this.currentPage = page
      this.updateQueryParams()
      this.getPagingList(this.currentPage)
    },
    updateQueryParams() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.search.title) {
        query.keyword = this.search.title
      }
      
      this.$router.replace({ query })
    },
    deleteFile(id){
      api.file.deleteFile({id},(response) => {
        this.getPagingList(this.currentPage)
      }, (err) => {
        console.log(err)
      })
    },
    getPagingList(page) {
      let param = {
        page: page,
        keyword: this.search.title,
      }
      
      api.file.searchFiles(param,(response) => {
        const {content, totalPages, totalElements} = response.data
        this.files = content
        this.totalPage = totalPages
        this.totalRows = totalElements
        this.currentPage = page
      }, (err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
.text-right{
  text-align: right;
}
</style>